import { useEffect } from 'react';
import styled from 'styled-components';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { Row } from 'antd';
import { IMAGES } from '~/assets/assetsPath';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import styles from './PageNotFound.module.scss';
import classNames from 'classnames/bind';
import config from '~/config';
const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    min-width: 350px;
    min-height: 200px;
    overflow: auto;
`;
const Container = styled.div``;

const PageNotFound = () => {
    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_Trang404NotFound');
        // eslint-disable-next-line
    }, []);

    const navigate = useNavigate();

    const cx = classNames.bind(styles);
    return (
        <>
            <div className={cx('body')}>
                <div className={cx('wrapper')}>
                    <div className={cx('error')}>
                        <div className={cx('container_err')}>
                            <img
                                src={IMAGES.NewLogoFooter}
                                alt=""
                                width="400px"
                                style={{
                                    cursor: 'pointer',
                                    height: '100%',
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                }}
                                onClick={() => navigate(config.routes.home)}
                            />
                            {/* <p className={cx('p')}>4</p>
                            <p className={cx('p')}>0</p>
                            <span className={cx('dracula')}>
                                <div className={cx('con')}>
                                    <div className={cx('hair')} />
                                    <div className={cx('hair-r')} />
                                    <div className={cx('head')} />
                                    <div className={cx('eye')} />
                                    <div className={cx('eye', 'eye-r')} />
                                    <div className={cx('mouth')} />
                                    <div className={cx('blod')} />
                                    <div className={cx('blod blod2')} />
                                </div>
                            </span>
                            <p className={cx('p')}>4</p> */}
                        </div>
                        <div className={cx('page-ms')}>
                            <p className={cx('page-msg')}> Oops, page not found </p>
                            <button className={cx('go-back')} onClick={() => navigate(config.routes.home)}>
                                Return to home page
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PageNotFound;
